import { Helmet } from "react-helmet-async";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Products } from "@/components/site/Products";
import { Pricing } from "@/components/site/Pricing";
import { Process } from "@/components/site/Process";
import { BlogPreview } from "@/components/site/BlogPreview";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="grain relative">
      <Helmet>
        <title>GMP Développement — Avis Google, chevalets NFC & solutions digitales</title>
        <meta
          name="description"
          content="GMP Développement : chevalets avis Google connectés (NFC & QR), menus digitaux et gestion de fiche Google Business en mode SaaS humain et sur mesure pour les marques et commerces."
        />
        <link rel="canonical" href={typeof window !== "undefined" ? window.location.origin + "/" : "/"} />
        <meta property="og:title" content="GMP Développement — Solutions digitales pour votre notoriété" />
        <meta property="og:description" content="Chevalets avis Google NFC, menus digitaux et gestion de fiche Google. Humain et sur mesure." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />
      <main>
        <Hero />
        <Products />
        <Process />
        <Pricing />
        <BlogPreview />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
